export default __webpack_public_path__ + "static/media/warning-image.e4295eae.svg";